import { Reveal } from "@/components/site/motion";
import { WHY_US } from "@/data/content";

const WhyUs = () => (
  <section className="bg-sand py-24 md:py-36">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        {/* Sticky editorial image */}
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <Reveal>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1734365294772-2f59212083d3?auto=compress&w=1200&q=80"
                alt="A compassionate counsellor"
                className="w-full h-[520px] object-cover arch-frame"
              />
              <div className="absolute -bottom-6 -right-4 md:right-6 bg-forest text-sand rounded-2xl p-6 max-w-[240px] shadow-[0_20px_40px_rgb(0,0,0,0.15)]">
                <p className="font-serif text-2xl leading-tight">{`“We walk with you for a lifetime.”`}</p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">Why Choose Us</p>
            <h2 className="font-serif text-4xl md:text-6xl text-forest tracking-tight leading-[1.02] mb-12">
              A holistic home for body, mind &amp; spirit
            </h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 gap-x-10 gap-y-12">
            {WHY_US.map((w, i) => {
              const Icon = w.icon;
              return (
                <Reveal key={w.title} delay={i * 0.1}>
                  <div className="grid place-items-center w-14 h-14 rounded-2xl bg-sage/20 text-forest mb-5">
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="font-serif text-2xl md:text-3xl text-forest mb-3">{w.title}</h3>
                  <p className="text-ink2 leading-relaxed">{w.desc}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WhyUs;
